import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FlightDocumentationSummary } from '@flyfreely-portal-ui/flyfreely';

/**
 * Displays the flight documentation summary, either on a single line
 * or expanded for inclusion in a popover.
 */
@Component({
    selector: 'flight-documentation-summary',
    templateUrl: './flight-documentation-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlightDocumentationSummaryComponent {
    @Input() summary: FlightDocumentationSummary | null = null;
    @Input() layout: 'INLINE' | 'EXPANDED' = 'INLINE';

    incomplete(step: 'pre-flight' | 'post-flight'): number {
        const stepSummary = this.summary?.[step];
        return stepSummary == null
            ? 0
            : stepSummary.total - stepSummary.completed;
    }
}
